import React, { useState, useEffect, useRef } from 'react'
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import PupUPbomList from './../popupbom/PupUPbomList';
import { styled } from '@mui/material/styles';
import './newdocument.scss';
import Field from './NdField';
import EditDetaildocument from './Editcomponent/EditDetaildocument';
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
import PopUpcustomers from './popupcomponent/popUpcustomers';
import PopUpItemdetail from './popupcomponent/popUpItemdetail';
import PopUpdetailSpecId from './popupcomponent/popUpdetailSpecId';
// import PopUpItemBrandcode from './popupcomponent/popUpItemBrandcode';
import FetchApi, { host } from '../../../customhooks/Functionapi';
import { useSelector, useDispatch } from 'react-redux'
import { UpdateDetailList } from '../../../customhooks/Functiondocument';
import { UploadFiles } from '../../../customhooks/FuctionUpload';
import Swal from 'sweetalert2';
import NavbarUser from '../../../../components/navbar/NavbarUser'
import { objectHearder, ItmeTypeID } from './objectdata/typeobject';
import ImageZoom from "react-image-zooom";
import SearchIcon from '@mui/icons-material/Search';
import PopUpEditJournalImages from './popupcomponent/popUpEditJournalImages';
import PopUpChangeFlow from './popupcomponent/popUpChangeFlow';
import PopUpPackagingDetail from './popupcomponent/popUpPackagingDetail';
import PopUpshowImages from './popupcomponent/popUpshowImages';
import moment from 'moment/moment.js';

// import moment from 'moment';

import { AddHeader, AddDetail, AddImages } from '../../../redux/features/document/documentHeaderSlice';
import {
    useParams
} from "react-router-dom";
import { Container } from '@mui/material';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const Editdocuments = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const FetchApis = new FetchApi()
    let { id } = useParams();


    const documentDetial = useSelector((state) => state.documentHeader.valueDetail);

    const d = new Date();
    let convertdate = ""
    let convertmonth = d.getMonth() + 1;

    if (d.getDate() < 10) {
        convertdate = "0" + d.getDate();
    }
    else {
        convertdate = d.getDate();
    }
    if (d.getMonth() + 1 < 10) {
        convertmonth = "0" + convertmonth
    }
    else {
        convertmonth = convertmonth
    }

    var datenow = d.getFullYear() + "-" + convertmonth + "-" + convertdate
    var datenowtime = d.getFullYear() + "-" + convertmonth + "-" + convertdate + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()

    const [addImages, setAddImages] = useState([]);
    const ref_imagse = useRef(null);
    const [dataHeader, setDataHeader] = useState({ ...objectHearder });
    const [HeaderTypeproduct, setHeaderTypeproduct] = useState([]);

    const [datatypeproduct, setDataTypeproduct] = useState([]);
    const [typeproductdetail, setTypeproductdetial] = useState([]);
    const [ischeck, setIscheck] = useState(false);
    // const [isload, setIsload] = useState(true);
    const [saleapproved, setSaleapproved] = useState([]);
    const [flowrunList, setFlowrunList] = useState([]);
    const [journalImages, setJournalImages] = useState([]);
    const [PurposeDetailList, setPurposeDetailList] = useState([]);



    const userId = sessionStorage.getItem("userId")

    function getdatadetail(data) {
        dispatch(AddDetail(data))
    }

    function getdataImages(data) {
        dispatch(AddImages(data))
    }


    useEffect(() => {

        getJournalById(id)
        gettypePorduct();
        getsaleapproved();


    }, [ref_imagse])

    //แสดงรูปที่ทำการบันทึก 
    const getjournalImagseList = (code) => {

        FetchApis.FethcGet(`/journalImages/JouranlImagesByCode/${code}`).then(res => {
            if (res) {
                setJournalImages(res.data);
            }
        })
    }

    // เรียก ประเภท  new  and revise
    const gettypePorduct = () => {

        FetchApis.FethcGet(`/typeproduct/typeProductgroup`).then(res => {
            if (res) {
                setDataTypeproduct(res.data)

            }
        })

    }

    function findTypeProduct(key) {
        var typeproductlist = HeaderTypeproduct.filter(val => val === key);
        return typeproductlist;
    }

    // กรณีกดแล้วให้แสดงหัวข้อมูล วัติถุประสงค์ตามกลุ่ม
    const gettypedetailproduct = (code) => {

        setIscheck(false)

        setTimeout(() => {
            setIscheck(true)
        }, 500);

        FetchApis.FethcGet(`/typeproduct/typeProductByCode/${code}`).then(res => {

            if (res) {
                setTypeproductdetial(res.data);
                dataHeader.Typeproduct = code;
              
            }
        })
    }

    // การเลือกหัวข้อมูล วัติถุประสงค์
    const handleChange = (e) => {

        const ischecked = e.target.checked;
        const istext = e.target.value;

        if (ischecked == true) {
            if (PurposeDetailList == "") {
                setPurposeDetailList([istext])
            }
            else {
                setPurposeDetailList([...PurposeDetailList, istext])
            }



        }
        else if (ischecked == false) {

            const index = PurposeDetailList.indexOf(e.target.value);
            PurposeDetailList.splice(index, 1);
            setPurposeDetailList(PurposeDetailList);

        }
    }


    //แสดงชื่อ flow หรือ ชื่อ sale
    const getsaleapproved = () => {

        FetchApis.FethcGet(`/flowsystem/flowgroupbyName`).then(res => {
            if (res) {
                setSaleapproved(res.data);
            }
        })
    }


    //  ส่วนกรเลือก sale เพิ่มแสดง flow running
    const isChangflow = (val) => {

        setDataHeader({ ...dataHeader, FlowrunId: val });

    }

    const handleChangeSale = (e) => {
        var val = e.target.value;
        setDataHeader({
            ...dataHeader, SaleAckUserID: val
        })

        FetchApis.FethcGet(`/flowsystem/flowbyNamelist/${val}`).then(res => {
            if (res) {
                if (res) {
                    setFlowrunList(res.data);
                }

            }
        })

    };


    const getJournalById = (jourId) => {

        FetchApis.FethcGet(`/document/DocumentById/${jourId}`).then(res => {
            if (res) {
                var dataItemTypeID = res.data[0]
                getjournalImagseList(res.data[0].JournalCode);
                gettypedetailproduct(res.data[0].Typeproduct);
                var datatypeproduct = res.data[0].Typeproduct.split(",");
                setHeaderTypeproduct(datatypeproduct);

                if (dataItemTypeID.ItemTypeID == "") {

                    setDataHeader({
                        ...res.data[0],
                        ItemTypeID: [],
                        PurposeDetail: [res.data[0].PurposeDetail]
                    })
                    var datapurpose = res.data[0].PurposeDetail.split(",");
                    var datatypeproduct = res.data[0].Typeproduct.split(",");
                    setPurposeDetailList(datapurpose);
                    setHeaderTypeproduct(datatypeproduct);

                    // get defulf tupeproduct detail list


                } else {
                    var itemtypeId = dataItemTypeID.ItemTypeID.split(',')
                    setDataHeader({
                        ...res.data[0],
                        ItemTypeID: itemtypeId,
                        PurposeDetail: [res.data[0].PurposeDetail]
                    })
                    var datapurpose = res.data[0].PurposeDetail.split(",");
                    var datatypeproduct = res.data[0].Typeproduct.split(",");

                    setPurposeDetailList(datapurpose);
                    setHeaderTypeproduct(datatypeproduct);
                }
            }

        })
    }

    const handleFile = event => {
        var input = document.getElementById('loadfile');

        if (input.files[0]) {
            const file = input.files[0]
            const size = file.size // it's in bytes
            const ext = file.name.split(".").pop();

            const newName = `${Date.now()}.` + ext;
            const renamedFile = new File([file], newName, {
                type: file.type,
            });

            if (size <= 5000000) {
                UploadFiles(renamedFile).then(res => { //upload file ก่อน ค่อย insert 
                    if (res) {
                        setDataHeader({ ...dataHeader, PartFileECN: newName })
                    }
                })
            } else {
                // alert('ขนาดใหญ่เกินไปครับกรุณาอยากเกิน 5M')
                Swal.fire({
                    title: "แจ้งเตือน",
                    text: "ขนาดไฟล์เกินกำหนด 5M ",
                    icon: "warning"
                });

            }

        }

    };

    function isRemoveImages(index) {
        const newArray = [...addImages];
        newArray.splice(index, 1);
        setAddImages(newArray);

    }

    function onCheckType(e) {
        const { ItemTypeID } = dataHeader;
        const value = e.target.value;
        setDataHeader({ ...dataHeader, ItemTypeID: value })
    }

    function inDataCustomer(customerName, codecustomer) {
        setDataHeader({ ...dataHeader, CustID: codecustomer, CustName: customerName })
    }


     function inDataCustomerDetail(BRANDCODE, ITEMID, ITEMNAME,SPECID,SPECNAME) {
        var databranid = BRANDCODE.replace("'", " ")

        setDataHeader({
            ...dataHeader,
            ItemID: ITEMID,
            BrandID: databranid,
            ItemName: ITEMNAME,
            SpecId:SPECID,
            SpecName:SPECNAME
        })
    }

    // ข้อมูลก่อน save
    const isSaveUpdate = () => {

        dataHeader.PurposeDetail = PurposeDetailList;
        dataHeader.stamptimeUpdate = datenowtime;
        dataHeader.ConfirmDateTime = datenow;

        if (dataHeader.FlowrunId != "") {

            isUpdateJournal(dataHeader)
            UpdateDetailList(documentDetial)
            setTimeout(() => {

                window.location.href = '/documents'

            }, 700);
        } else {
            Swal.fire({
                title: "แจ้งเตือน",
                text: "คุณยังไม่ได้เลือกเป็น flow อนุมัติ",
                icon: "warning"
            });

        }


    };
    // update 
    const isUpdateJournal = (datainsert) => {

        FetchApis.FethcUpdate(`/document/updateDocument/${datainsert.JournalID}`, datainsert).then(res => {
            if (res.status == 200) {

                Swal.fire({
                    title: "แจ้งการบันทึก",
                    text: "คุณสร้างเอกสารเรียบร้อยแล้ว",
                    icon: "success"
                });

                setTimeout(() => {
                    window.location.href = '/documents'
                }, 1000);



            } else {
                console.log(res)
            }

        })
    }

    function findArrayElementByTitle(key) {

        var typeItem = PurposeDetailList.filter(val => val === key);

        return typeItem;
    }


    const handleChangeText = e => {
        var input = e.target.value;
        const cleanInput = input.replace(/[^a-zA-Z0-9ก-๙\s()#/.%:";,=\-&@$<>+*/?!]/g, "");
        setDataHeader({ ...dataHeader, [e.target.name]: cleanInput });
    };

    const inDetailSpec = (SPECID, SPECNAME) => {
        setDataHeader({
            ...dataHeader,
            SpecId: SPECID,
            SpecName: SPECNAME
        })
    }


    function RevoveImage(id) {
        UpdateDetailList(documentDetial)
        Swal.fire({
            title: "แจ้งการลบ?",
            text: "คุณแน่ใจที่ลบข้อมูล ใช่หรือไม่ !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ลบเอกสาร",
            cancelButtonText: 'ยกเลิก'
        }).then((result) => {
            if (result.isConfirmed) {

                FetchApis.FethcDelete(`/journalImages/JournalImagsById/${id}`).then(res => {
                    if (res) {
                        window.location.reload();
                    }
                })

            }
        });

    }

    const isGetPacklist = (datalist) => {
        setDataHeader({ ...dataHeader, PackagingDetails: datalist })
    }

    // show data images list from 
    function Retureimag() {

        return (<div style={{ width: '100%' }}>

            {journalImages.map((val, index) =>
                <Box sx={{ height: 'auto', marginTop: '1', padding: 1, width: '100%', display: 'flex', fontSize: 14 }}>
                    <div className='row-pace-w100-line'
                        style={{ backgroundColor: '#faf8f8', padding: 10 }}>
                        {/* ส่วนที่1 */}
                        <div style={{ width: '25%' }}>
                            <div style={{
                                width: 50, height: 30, backgroundColor: '#2c82c6', color: '#ffff', flexDirection: 'row',
                                alignItems: 'center', display: 'flex'
                            }}>
                                <label>No.{index + 1}</label>
                            </div>
                            <div>
                                <div style={{ marginBottom: 5 }}>
                                    <label>หัวข้อ</label>
                                    <div style={{ marginLeft: 20, padding: 10, backgroundColor: '#E6EBEA' }}>
                                        <label>{val.SubjectDetails}</label>
                                    </div>

                                </div>
                                <div>
                                    <label>รายละเอียด</label>
                                    <div style={{ marginLeft: 20, backgroundColor: '#E6EBEA' }}>
                                        <label
                                            style={{
                                                display: "block",
                                                whiteSpace: "pre-wrap", // ✅ เคารพการเคาะบรรทัด
                                                border: "1px solid #ccc",
                                                padding: "8px",
                                                minHeight: "auto",
                                                width: "100%",
                                                // background: "#f9f9f9"
                                            }}
                                        >{val.SubjectExtend}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* ส่วนที่2 */}
                        <div style={{ width: '65%', padding: 10 }} className='row-pace-w100-line'>
                            <div style={{
                                width: '100%', height: 320, backgroundColor: "#d6d8d7"
                            }}>

                                <div>ภาพประกอบ : {val.PkDescription} {val.ItemID}</div>
                                 <img src={host + `/file/images/files/${val.LocationPic}`} alt="My local" style={{ width: '100%', height: 280 }}/>
                            </div>
                            <div>
                                <div>
                                    
                                     <PopUpshowImages nameimage={val.LocationPic} PkDescription={val.SubjectDetails} ItemID={val.ItemID}/>
                                </div>
                            </div>
                        </div>
                        {/* ส่วนที่3 */}
                        <div style={{ width: '20%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>

                                <div>
                                    <div style={{ backgroundColor: '#e0fbeb', alignItems: 'center', display: 'flex', padding: 10 }}>
                                        <CheckCircleOutlineIcon sx={{ color: '#39995f' }} />
                                        <label style={{ color: '#39995f' }}>Confirmed</label>
                                    </div>
                                    <center>
                                        <div>
                                            <label>Prepared By </label>
                                            <div>
                                                <label style={{ fontSize: 12 }}> {val.NameUserConfirm} {val.lastnameUserConfirm} </label>
                                            </div>
                                            <hr />
                                        </div>
                                        <div>
                                            <label>create datetime</label>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: 12 }}>{moment(val.ConfirmDateTime).format('DD/MM/yyyy hh:mm:ss')}</label>
                                        </div>
                                    </center>
                                </div>

                                <div ref={props.ref_imagse}>
                                    <div style={{ flexDirection: 'row', justifyContent: 'center', display: 'flex' }}>

                                        <div style={{ marginTop: 5, marginRight: 30, flexDirection: 'row', justifyContent: 'flex-end', display: 'flex' }}>
                                            <Button variant="outlined" size="small" color='error' onClick={() => RevoveImage(val.JournalID)}>Remove</Button>
                                        </div>
                                        <PopUpEditJournalImages
                                            getdataImages={props.getdataImages}
                                            documentDetial={documentDetial}
                                            valDateail={""}
                                            SlotNo={""}
                                            ItemName={""}
                                            ItemID={""}
                                            JourId={val.JourId}
                                            getjourDetailList={""}
                                            JournalID={val.JournalID}

                                        />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </Box>)}

        </div>)
    }


    return (
        <div className='nd-page' style={{ backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
            <React.Fragment >
                <NavbarUser />
                <CssBaseline />
                <div className='nd-toolbar'>
                    <div>
                        <div className='nd-toolbar-title'>แก้ไขเอกสาร</div>
                        <div className='nd-toolbar-sub'>
                            {dataHeader.JournalCode ? `เลขที่เอกสาร ${dataHeader.JournalCode}` : 'กำลังโหลดข้อมูลเอกสาร...'}
                        </div>
                    </div>
                    <div className='nd-toolbar-actions'>
                        <Button variant="outlined" color='inherit' startIcon={<CloseIcon />} onClick={() => navigate(-1)}>ยกเลิก</Button>
                        <Button variant="contained" color="success" startIcon={<SaveIcon />} onClick={() => isSaveUpdate()}>บันทึก</Button>
                    </div>
                </div>
                <Container maxWidth={false}>
                    {HeaderTypeproduct.length > 0 &&
                        // grid 2x2 แบบเดียวกับหน้าสร้างเอกสารใหม่ (Newdocuments)
                        <div className='nd-columns'>

                            {/* ข้อมูลเอกสาร */}
                            <section className='nd-card nd-pos-1'>
                                <div className='nd-card-head'>
                                    <span className='nd-card-title'>ข้อมูลเอกสาร</span>
                                </div>
                                <div className='nd-grid nd-grid-4'>
                                    <Field label='เอกสารบรรจุ (SSD)'>
                                        <input type='text' disabled className='nd-input nd-input-code' value={dataHeader.JournalCode}
                                            onChange={(e) => setDataHeader({ ...dataHeader, JournalCode: e.target.value })} />
                                    </Field>
                                    <Field label='วันที่สร้างเอกสาร'>
                                        <div className='nd-static'>{moment(dataHeader.TransDate).format('DD/MM/yyyy')}</div>
                                    </Field>
                                    <Field label='วันที่ Approved'>
                                        <div className='nd-static'>{moment(dataHeader.LastApprovedDate).format('DD/MM/yyyy')}</div>
                                    </Field>
                                    <Field label='เลขที่เอกสาร (ECN)' required>
                                        <input type='text' className='nd-input'
                                            value={dataHeader.RefECN}
                                            onChange={(e) => setDataHeader({ ...dataHeader, RefECN: e.target.value })} />
                                    </Field>
                                    <Field label='ไฟล์แนบ ECN' span={4}>
                                        <div className='nd-upload'>
                                            <Button variant="outlined" size="small"
                                                component="label"
                                                role={undefined}
                                                tabIndex={-1}
                                                startIcon={<CreateNewFolderIcon />}>
                                                Upload files
                                                <VisuallyHiddenInput
                                                    type="file" accept="image/*,.pdf" onChange={handleFile} id='loadfile'
                                                    multiple
                                                />
                                            </Button>
                                            <span className={dataHeader.PartFileECN ? 'nd-file' : 'nd-file nd-muted'}>
                                                {dataHeader.PartFileECN || 'ยังไม่ได้เลือกไฟล์ (รูปภาพ หรือ pdf ไม่เกิน 5MB)'}
                                            </span>
                                        </div>
                                    </Field>
                                </div>
                            </section>

                            {/* ส่วนของคำร้องขอ */}
                            <section className='nd-card nd-pos-3'>
                                <div className='nd-card-head'>
                                    <span className='nd-card-title'>ส่วนของคำร้องขอ</span>
                                </div>
                                <div className='nd-grid nd-grid-2'>
                                    <Field label='ประเภทสินค้า' span={2}>
                                        <div className='nd-choices'>
                                            {ItmeTypeID.map((val, index) => (
                                                <label className='nd-chip' key={index}>
                                                    <input type='radio' name='1' value={val} onClick={(e) => onCheckType(e)}
                                                        defaultChecked={dataHeader.ItemTypeID == val} />
                                                    <span>{val}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </Field>

                                    <Field label='ประเภทงาน'>
                                        <div className='nd-choices'>
                                            {datatypeproduct.map((item, index) => (
                                                <label className='nd-chip' key={index}>
                                                    <input type='radio' name='typeproduct' value={item.typecode}
                                                        onClick={(e) => gettypedetailproduct(e.target.value)}
                                                        defaultChecked={findTypeProduct(item.typecode) == item.typecode} />
                                                    <span>{item.typeproduct}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </Field>

                                    <Field label='รายละเอียดงาน'>
                                        {typeproductdetail.length > 0 && ischeck != false ?
                                            <div className='nd-checklist'>
                                                {typeproductdetail.map((item, index) => (
                                                    <label className='nd-check' key={index}>
                                                        <input type='checkbox' value={item.detailproduct} name={'typeDetail'}
                                                            onChange={(e) => handleChange(e)}
                                                            defaultChecked={findArrayElementByTitle(item.detailproduct) == item.detailproduct}
                                                        />
                                                        <span>{item.detailproduct}</span>
                                                    </label>
                                                ))}
                                            </div> :
                                            <div className='nd-static nd-muted'>เลือกประเภทงานก่อน</div>
                                        }
                                    </Field>

                                    <Field label='วัตถุประสงค์' span={2}>
                                        <textarea className='nd-input nd-textarea'
                                            name='Purpose'
                                            value={dataHeader.Purpose}
                                            onChange={(e) => handleChangeText(e)}
                                            placeholder='อธิบายคำร้อง (500 Digit)'
                                            maxLength={500}
                                        />
                                    </Field>

                                    <Field label='ลำดับอนุมัติ'>
                                        <select className='nd-input' name="flowapproved" id="flowapproved" disabled
                                            onChange={(e) => isChangflow(e.target.value)}>
                                            <option value={dataHeader.FlowrunId}>{dataHeader.flowDetail}</option>
                                            {flowrunList.map((item, index) => (
                                                <option key={index} value={item.flowId}>{item.detail}</option>
                                            ))}
                                        </select>
                                    </Field>

                                    <Field label='เปลี่ยน flow'>
                                        <div className='nd-static'>
                                            <PopUpChangeFlow jourId={dataHeader.JournalID} />
                                        </div>
                                    </Field>

                                    <Field label='ผู้ร้องขอ' span={2}>
                                        <input type='text'
                                            name='UserIDRequest'
                                            value={dataHeader.UserIDRequest}
                                            onChange={(e) => handleChangeText(e)}
                                            placeholder='ชื่อ / สกุล' className='nd-input' />
                                    </Field>
                                </div>
                            </section>

                            {/* ข้อมูลลูกค้า / สินค้า */}
                            <section className='nd-card nd-pos-2'>
                                <div className='nd-card-head'>
                                    <span className='nd-card-title'>ข้อมูลลูกค้า / สินค้า</span>
                                </div>
                                <div className='nd-grid nd-grid-cust'>
                                    <Field label='รหัสลูกค้า'>
                                        <div className='nd-input-group'>
                                            <input type='text' className='nd-input' value={dataHeader.CustID}
                                                onChange={(e) => setDataHeader({ ...dataHeader, CustID: e.target.value })} />
                                            <span className='nd-picker' title='ค้นหาลูกค้า'>
                                                <PopUpcustomers inDataCustomer={inDataCustomer} />
                                            </span>
                                        </div>
                                    </Field>
                                    <Field label='ชื่อลูกค้า'>
                                        <input type='text'
                                            name='CustName'
                                            value={dataHeader.CustName}
                                            onChange={(e) => handleChangeText(e)}
                                            className='nd-input' />
                                    </Field>

                                    <Field label='รหัสสินค้า'>
                                        <div className='nd-input-group'>
                                            <input type='text' className='nd-input'
                                                value={dataHeader.ItemID}
                                                name='ItemID'
                                                onChange={(e) => handleChangeText(e)}
                                            />
                                            <span className='nd-picker' title='ค้นหาสินค้า'>
                                                <PopUpItemdetail inDataCustomerDetail={inDataCustomerDetail} />
                                            </span>
                                        </div>
                                    </Field>
                                    <Field label='ชื่อสินค้า'>
                                        <input type='text'
                                            name='ItemName'
                                            value={dataHeader.ItemName}
                                            onChange={(e) => handleChangeText(e)}
                                            className='nd-input' />
                                    </Field>

                                    <Field label='ตราสินค้า'>
                                        <input type='text'
                                            name='BrandID'
                                            value={dataHeader.BrandID}
                                            onChange={(e) => handleChangeText(e)}
                                            className='nd-input'
                                        />
                                    </Field>
                                </div>
                            </section>

                            {/* การบรรจุ / Spec */}
                            <section className='nd-card nd-pos-4'>
                                <div className='nd-card-head'>
                                    <span className='nd-card-title'>การบรรจุ / Spec</span>
                                    <span className='nd-card-action'>
                                        {dataHeader.ItemID ? <PupUPbomList ItemId={dataHeader.ItemID} /> : <span className='nd-hint'>เลือกรหัสสินค้าก่อน เพื่อดูข้อมูล BOM</span>}
                                    </span>
                                </div>
                                <div className='nd-grid nd-grid-2'>
                                    <Field label='การบรรจุงาน'>
                                        <div className='nd-input-group'>
                                            <input type='text'
                                                name='PackagingDetails'
                                                value={dataHeader.PackagingDetails}
                                                onChange={(e) => handleChangeText(e)}
                                                className='nd-input' />
                                            <span className='nd-picker' title='เลือกการบรรจุ'>
                                                <PopUpPackagingDetail isGetPacklist={isGetPacklist} />
                                            </span>
                                        </div>
                                    </Field>
                                    <Field label='Spec ID'>
                                        <div className='nd-input-group'>
                                            <input type='text'
                                                name='SpecId'
                                                value={dataHeader.SpecId}
                                                onChange={(e) => handleChangeText(e)}
                                                className='nd-input'
                                            />
                                            <span className='nd-picker' title='ค้นหา Spec'>
                                                <PopUpdetailSpecId inDetailSpec={inDetailSpec} />
                                            </span>
                                        </div>
                                    </Field>
                                    <Field label='Spec Detail' span={2}>
                                        <input type='text'
                                            name='SpecName'
                                            value={dataHeader.SpecName}
                                            onChange={(e) => handleChangeText(e)}
                                            className='nd-input' />
                                    </Field>
                                    <Field label='อธิบายเพิ่มเติม 1' span={2}>
                                        {/* SDSS_Head.Remark เป็น varchar(150) */}
                                        <textarea className='nd-input nd-textarea nd-textarea-remark'
                                            name='Remark'
                                            value={dataHeader.Remark}
                                            onChange={(e) => handleChangeText(e)}
                                            placeholder='อธิบายเพิ่มเติม (150 Digit)'
                                            maxLength={150}
                                        />
                                    </Field>
                                </div>
                                <div className='nd-meta'>
                                    <span><b>Confirm By :</b> {dataHeader.nameConfirme} {dataHeader.lastname}</span>
                                    <span><b>วันที่สร้าง :</b> {moment(dataHeader.TransDate).format('DD/MM/yyyy')}</span>
                                </div>
                            </section>
                        </div>}

                </Container>

            </React.Fragment>

            <div>
                {dataHeader.JournalID != "" &&
                    <EditDetaildocument
                        getdatadetail={getdatadetail}
                        isRemoveImages={isRemoveImages}
                        getdataImages={getdataImages}
                        dataHeader={dataHeader}
                        HdJourCode={dataHeader.JournalCode}
                        sectionHeader={true}
                    />
                }
            </div>
            <div>
                <Container maxWidth={false}>
                    {journalImages.length > 0 ? <div>
                        <div className='nd-detail-bar'>
                            <span className='nd-card-title'>รูปประกอบเพิ่มเติม</span>
                            <span className='nd-detail-count'>{journalImages.length} รายการ</span>
                        </div>
                        <Retureimag />
                    </div> : <div>

                    </div>}
                </Container>
            </div>
        </div>
    )
}

export default Editdocuments